import {
    faBorderNone,
    faCalendarTimes, faCheckCircle, faExclamationCircle,
    faExclamationTriangle, faEye, faEyeSlash,
    faFemale,
    faHospitalSymbol, faMale,
    faRuler,
    faShareSquare,
    faSyringe, faVenus,
    faWeight
} from '@fortawesome/free-solid-svg-icons';
import {faMars} from '@fortawesome/free-solid-svg-icons/faMars';

export class IconUtil {

    static getIcon(ref: string) {
        switch (ref) {
            case 'calendar-times':
                return faCalendarTimes;
            case 'exclamation-triangle':
                return faExclamationTriangle;
            case 'attention':
                return faExclamationCircle;
            case 'share-square':
                return faShareSquare;
            case 'hospital-symbol':
                return faHospitalSymbol;
            case 'weight':
                return faWeight;
            case 'height':
                return faRuler;
            case 'syringe':
                return faSyringe;
            case 'checkmark-circle':
                return faCheckCircle;
            case 'alert-icon':
                return faExclamationTriangle;
            case 'eye':
                return faEye;
            case 'block-eye':
                return faEyeSlash;
            // case 'pregnant-woman':
            //     return faPersonPregnant;
            // case 'children':
            //     return faChildren;
            case 'female':
                return faVenus;
            case 'male':
                return faMars;
            default:
                return faBorderNone;
        }
    }

    static getExpiredVisitIcon() {
        return {
            icon: 'calendar-times',
            class: 'calendar-icon'
        };
    }


}
